import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/solicitacao`

    return {
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        index(pacienteId) {
            return repository.get(`${baseUrl}/${pacienteId}`)
        },
        list(queryParms = {}) {
            return repository.post(`${baseUrl}/list`, queryParms)
        },
        create(id) {
            return repository.get(`${baseUrl}/create/${id}`)
        },
        exame: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-exame?${urlUtil.serialize(queryParms)}`)
            },
        },
        especialidade: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-especialidade?${urlUtil.serialize(queryParms)}`)
            },
        },
        procedimentoCirurgico: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-procedimento-cirurgico?${urlUtil.serialize(queryParms)}`)
            },
        },
        store(queryParms = {}) {
            return repository.post(`${baseUrl}`, queryParms)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, queryParms = {}) {
            return repository.put(`${baseUrl}/${id}`, queryParms)
        },
        cancel(id, queryParms = {}) {
            return repository.put(`${baseUrl}/cancel/${id}`, queryParms)
        },
        getInfoProfissional(queryParms = {}) {

            return repository.get(`${baseUrl}/get-info-profissional?${urlUtil.serialize(queryParms)}`)
        },
        getAgendamentoExameNoPrazoDeValidade(pacienteId, exameId) {
            return repository.get(`${baseUrl}/agendamento-exame-prazo-validade/${pacienteId}/${exameId}`)
        },
    }

}